export enum PublishStatus {
  Published = 'Published',
  Unpublished = 'Unpublished',
  Flagged = 'Flagged',
}
